/*!

=========================================================
* Material Dashboard React - v1.9.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/material-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
// @mui/icons-material
import AdminUserManagement from '@/views/Admin/AdminUserManagement';
import RoleManagement from '@/views/Admin/RoleManagement/RoleManagement';
import RoleDetails from '@/views/Admin/RoleDetails';
import CustomPaymentTypes from '@/views/Admin/CustomPayments/CustomPaymentTypes';
import CreateOrEditCustomPaymentType from '@/views/Admin/CustomPayments/CreateOrEditCustomPaymentType';
import FacilityTransaction from '@/views/Clients/FacilityTransaction';
import Transactions from '@/views/Transactions/Transactions';
import TransactionDetails from '@/views/Transactions/TransactionDetails';
import ACHFiles from '@/views/Dashboard/ACHFiles';
import AchPayments from '@/views/Dashboard/Achpayments';
// core components/views for Admin layout
import DashboardPage from '@/views/Dashboard/Dashboard';
import PostageAccounting from '@/views/Dashboard/PostageAccounting';
import UploadedFiles from '@/views/Dashboard/UploadedFiles';
import AddMoovPaymentMethod from '@/views/Facilities/AddMoovPaymentMethod';
import Approvals from '@/views/Facilities/Approvals';
import CreateFacility from '@/views/Facilities/CreateFacility';
import CreateMoovAccount from '@/views/Facilities/CreateMoovAccount';
import CreateOrUpdateSmartPayablesAccount from '@/views/Facilities/CreateOrUpdateSmartPayablesAccount';
import CreateTangoAccount from '@/views/Facilities/CreateTangoAccount';
import CreateTangoGroup from '@/views/Facilities/CreateTangoGroup';
import FacilitiesPage from '@/views/Facilities/FacilitiesPage';
import MoovPage from '@/views/Facilities/MoovPage';
import SmartPayablesPage from '@/views/Facilities/SmartPayablesPage';
import TangoPage from '@/views/Facilities/TangoPage';
import UpdateFacility from '@/views/Facilities/UpdateFacility';
import UserManagement from '@/views/Facilities/UserManagement/UserManagement';
import UserDetails from '@/views/Facilities/UserDetails';
import AdminReport from '@/views/Managefile/AdminReporting';
import CreateOrganization from '@/views/Organizations/CreateOrganization';
import Organizations from '@/views/Organizations/Organizations';
import UpdateOrganization from '@/views/Organizations/UpdateOrganization';
import ClientBankAccountDetails from '@/views/Organizations/ClientBankAccountDetails';
import SftpConnectionDetails from '@/views/Organizations/SftpConnectionDetails';
import FacilityGroupDetails from '@/views/Organizations/FacilityGroups/FacilityGroupDetails';
import FacilitySettings from '@/views/Settings/FacilitySettings';
import GlobalSettings from '@/views/Settings/GlobalSettings';
import ActivateUser from '@/views/UserProfile/ActivateUser';
import ForgotPassword from '@/views/UserProfile/ForgotPassword';
import Login from '@/views/UserProfile/Login';
import Loginfacility from '@/views/UserProfile/Loginfacility';
import Resetpassword from '@/views/UserProfile/Resetpassword';
import {
  Assessment,
  CloudDownloadRounded,
  MonetizationOn,
  PersonAdd,
  ReportProblemRounded,
  AccountBalanceOutlined,
  Security,
} from '@mui/icons-material';
import Business from '@mui/icons-material/Business';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import Dashboard from '@mui/icons-material/Dashboard';
import Language from '@mui/icons-material/Language';
import Payment from '@mui/icons-material/Payment';
import Person from '@mui/icons-material/Person';
import SettingsIcon from '@mui/icons-material/Settings';
import Exceptions from '@/views/Facilities/Exceptions';
import SmartPayablesManagement from '@/views/Facilities/SmartPayablesManagement';

const dashboardRoutes = [
  {
    path: '/dashboard',
    name: 'Dashboard',
    translationKey: 'sidebar.dashboard',
    rtlName: 'قائمة الجدول',
    icon: Dashboard,
    component: DashboardPage,
    layout: '/admin',
  },
  {
    path: '/accounting',
    name: 'Accounting',
    translationKey: 'sidebar.accounting',
    rtlName: 'قائمة الجدول',
    icon: Assessment,
    component: PostageAccounting,
    layout: '/admin',
  },
  {
    path: '/adminUserManagement',
    name: 'Manage Admin Users',
    translationKey: 'sidebar.manageAdminUsers',
    rtlName: 'قائمة الجدول',
    icon: PersonAdd,
    component: AdminUserManagement,
    layout: '/admin',
  },
  {
    path: '/roles',
    name: 'Role Management',
    rtlName: 'إدارة الأدوار',
    icon: Security,
    component: RoleManagement,
    layout: '/admin',
  },
  {
    path: '/roles/:roleId',
    name: 'Role Details',
    rtlName: 'تفاصيل الدور',
    icon: Security,
    component: RoleDetails,
    layout: '/admin',
    invisible: true,
  },
  {
    path: '/custom-payment-types',
    name: 'Custom Payment Types',
    rtlName: 'المدفوعات المخصصة',
    icon: Payment,
    component: CustomPaymentTypes,
    layout: '/admin',
    invisible: true,
  },
  {
    path: '/custom-payment-types/create',
    name: 'Create Custom Payment Type',
    rtlName: 'إنشاء دفع مخصص',
    icon: Payment,
    component: CreateOrEditCustomPaymentType,
    layout: '/admin',
    invisible: true,
  },
  {
    path: '/custom-payment-types/:id/edit',
    name: 'Edit Custom Payment Type',
    rtlName: 'تحرير الدفع المخصص',
    icon: Payment,
    component: CreateOrEditCustomPaymentType,
    layout: '/admin',
    invisible: true,
  },
  {
    path: '/organizations',
    name: 'Organizations',
    translationKey: 'sidebar.organizations',
    rtlName: '',
    icon: Business,
    component: Organizations,
    layout: '/admin',
  },
  {
    path: '/facilities',
    name: 'Facilities',
    translationKey: 'sidebar.facilities',
    rtlName: 'ملف تعريفي للمستخدم',
    icon: Business,
    component: FacilitiesPage,
    layout: '/admin',
  },

  {
    path: '/usermanagement',
    name: 'Manage Facility Users',
    translationKey: 'sidebar.manageFacilityUsers',
    rtlName: 'قائمة الجدول',
    icon: PersonAdd,
    component: UserManagement,
    layout: '/admin',
  },
  {
    path: '/usermanagement/:userId',
    name: 'User Details',
    rtlName: 'تفاصيل المستخدم',
    icon: PersonAdd,
    component: UserDetails,
    layout: '/admin',
    invisible: true,
  },
  {
    path: '/TangoPage',
    name: 'Manage Tango',
    translationKey: 'sidebar.manageTango',
    rtlName: 'قائمة الجدول',
    icon: CardGiftcardIcon,
    component: TangoPage,
    layout: '/admin',
  },
  {
    path: '/MoovPage',
    name: 'Manage Moov',
    translationKey: 'sidebar.manageMoov',
    rtlName: 'قائمة الجدول',
    icon: MonetizationOn,
    component: MoovPage,
    layout: '/admin',
  },
  {
    path: '/checkManagement',
    name: 'Check Management',
    translationKey: 'sidebar.checkManagement',
    rtlName: 'قائمة الجدول',
    icon: AccountBalanceOutlined,
    component: SmartPayablesPage,
    layout: '/admin',
  },
  {
    path: '/checkManagement/create',
    name: 'Create SmartPayables Account',
    rtlName: 'قائمة الجدول',
    icon: 'content_paste',
    component: CreateOrUpdateSmartPayablesAccount,
    layout: '/admin',
    invisible: true,
  },
  {
    path: '/checkManagement/edit/:id',
    name: 'Edit SmartPayables Account',
    rtlName: 'قائمة الجدول',
    icon: 'content_paste',
    component: CreateOrUpdateSmartPayablesAccount,
    layout: '/admin',
    invisible: true,
  },
  {
    path: '/checkManagement/management',
    name: 'SmartPayables Management',
    icon: AccountBalanceOutlined,
    component: SmartPayablesManagement,
    layout: '/admin',
    invisible: true,
  },
  // {
  //   path: '/refunds',
  //   name: 'Refunds',
  //   rtlName: 'ملف تعريفي للمستخدم',
  //   icon: Person,
  //   component: Refunds,
  //   layout: '/admin',
  // },
  {
    path: '/ach',
    name: 'ACH / Check Transactions',
    translationKey: 'sidebar.achCheckTransactions',
    rtlName: 'ملف تعريفي للمستخدم',
    icon: Person,
    component: AchPayments,
    layout: '/admin',
  },
  {
    path: '/transfers',
    name: 'Transactions',
    translationKey: 'sidebar.transactions',
    rtlName: 'التحويلات',
    icon: MonetizationOn,
    component: Transactions,
    layout: '/admin',
  },
  {
    path: '/transfers/:transferId',
    name: 'Transfer Details',
    rtlName: 'تفاصيل التحويل',
    icon: MonetizationOn,
    component: TransactionDetails,
    layout: '/admin',
    invisible: true,
  },
  {
    path: '/transaction',
    name: 'Payments',
    translationKey: 'sidebar.payments',
    rtlName: 'ملف تعريفي للمستخدم',
    icon: Payment,
    component: () => (
      <>
        <FacilityTransaction role='admin' />
      </>
    ),
    layout: '/admin',
  },
  {
    path: '/uploadedrefundfile',
    name: 'Refund Files',
    translationKey: 'sidebar.refundFiles',
    rtlName: 'قائمة الجدول',
    icon: CloudUploadIcon,
    component: UploadedFiles,
    layout: '/admin',
  },
  {
    path: '/allachFiles',
    name: 'Ach / Positive Pay Files',
    translationKey: 'sidebar.achPositivePayFiles',
    rtlName: 'قائمة الجدول',
    icon: CloudUploadIcon,
    component: ACHFiles,
    layout: '/admin',
  },
  {
    path: '/reports',
    name: 'Reports',
    translationKey: 'sidebar.reports',
    rtlName: 'قائمة الجدول',
    icon: CloudDownloadRounded,
    component: AdminReport,
    layout: '/admin',
  },
  {
    path: '/createFacility',
    name: '',
    rtlName: 'قائمة الجدول',
    icon: 'content_paste',
    component: CreateFacility,
    layout: '/admin',
    invisible: true,
  },

  {
    path: '/updatefacility/:id',
    name: 'Update Facility',
    rtlName: 'قائمة الجدول',
    icon: 'content_paste',
    component: UpdateFacility,
    layout: '/admin',
    invisible: true,
  },
  {
    path: '/CreateMoovGroup',
    name: 'Update Charity',
    rtlName: 'قائمة الجدول',
    icon: 'content_paste',
    component: CreateMoovAccount,
    layout: '/admin',
    invisible: true,
  },
  {
    path: '/AddMoovPaymentMethod',
    name: 'Update Charity',
    rtlName: 'قائمة الجدول',
    icon: 'content_paste',
    component: AddMoovPaymentMethod,
    layout: '/admin',
    invisible: true,
  },
  {
    path: '/CreateTangoGroup',
    name: 'Update Charity',
    rtlName: 'قائمة الجدول',
    icon: 'content_paste',
    component: CreateTangoGroup,
    layout: '/admin',
    invisible: true,
  },
  {
    path: '/CreateTangoAccount',
    name: 'Update Charity',
    rtlName: 'قائمة الجدول',
    icon: 'content_paste',
    component: CreateTangoAccount,
    layout: '/admin',
    invisible: true,
  },

  {
    path: '/login',
    name: 'Login',
    rtlName: 'پشتیبانی از راست به چپ',
    icon: Language,
    component: Login,
    layout: '/user',
    invisible: true,
  },

  {
    path: '/global-settings',
    name: 'Global Settings',
    translationKey: 'sidebar.globalSettings',
    rtlName: 'إعدادات عامة',
    icon: SettingsIcon,
    component: GlobalSettings,
    layout: '/admin',
  },
  {
    path: '/facility-settings/:id',
    name: 'Facility Settings',
    rtlName: 'إعدادات المنشأة',
    icon: SettingsIcon,
    component: FacilitySettings,
    layout: '/admin',
    invisible: true,
  },
  {
    path: '/facilitylogin',
    name: 'Facility Login',
    rtlName: 'پشتیبانی از راست به چپ',
    icon: Language,
    component: Loginfacility,
    layout: '/user',
    invisible: true,
  },

  {
    path: '/forgotpassword',
    name: 'Forgot Password',
    rtlName: 'پشتیبانی از راست به چپ',
    icon: Language,
    component: ForgotPassword,
    layout: '/user',
    invisible: true,
  },
  {
    path: '/resetpassword/',
    name: 'Reset Password',
    rtlName: 'پشتیبانی از راست به چپ',
    icon: Language,
    component: Resetpassword,
    layout: '/user',
    invisible: true,
  },
  {
    path: '/activation/:encoded',
    name: 'User activation',
    rtlName: 'پشتیبانی از راست به چپ',
    icon: Language,
    component: ActivateUser,
    layout: '/user',
    invisible: true,
  },
  {
    path: '/createOrganization',
    name: '',
    rtlName: '',
    icon: 'content_paste',
    component: CreateOrganization,
    layout: '/admin',
    invisible: true,
  },
  {
    path: '/updateOrganization/:id',
    name: '',
    rtlName: '',
    icon: 'content_paste',
    component: UpdateOrganization,
    layout: '/admin',
    invisible: true,
  },
  {
    path: '/organizations/:id/bank-accounts/:accountId',
    name: 'Client Bank Account Details',
    rtlName: '',
    icon: 'content_paste',
    component: ClientBankAccountDetails,
    layout: '/admin',
    invisible: true,
  },
  {
    path: '/organizations/:id/sftp-connections/:connectionId',
    name: 'SFTP Connection Details',
    rtlName: '',
    icon: 'content_paste',
    component: SftpConnectionDetails,
    layout: '/admin',
    invisible: true,
  },
  {
    path: '/updateOrganization/:id/facility-groups/:groupId',
    name: 'Facility Group Details',
    rtlName: '',
    icon: 'content_paste',
    component: FacilityGroupDetails,
    layout: '/admin',
    invisible: true,
  },
  {
    path: '/approvals',
    name: 'Approvals',
    translationKey: 'sidebar.approvals',
    rtlName: 'الموافقات',
    icon: PersonAdd,
    component: () => <Approvals role='admin' />,
    layout: '/admin',
  },
  {
    path: '/exceptions',
    name: 'Resolution Center',
    translationKey: 'sidebar.resolutionCenter',
    icon: ReportProblemRounded,
    component: () => <Exceptions role='admin' />,
    layout: '/admin',
  },

  /* {
     path: "/typography",
     name: "Typography",
     rtlName: "طباعة",
     icon: LibraryBooks,
     component: Typography,
     layout: "/admin"
   },
   {
     path: "/icons",
     name: "Icons",
     rtlName: "الرموز",
     icon: BubbleChart,
     component: Icons,
     layout: "/admin"
   },
   {
     path: "/maps",
     icon: Notifications,
     component: NotificationsPage,
     layout: "/admin"
   },
   {
     path: "/rtl-page",
     name: "RTL Support",
     rtlName: "پشتیبانی از راست به چپ",
     icon: Language,
     component: RTLPage,
     layout: "/rtl"
   }*/
];

export const routes = dashboardRoutes;
